import classNames from "classnames/dedupe";
import React, { FC, useState, useCallback } from "react";
import { FitFinderIcon } from "../../../icons";
import LinkButton, { TLinkButtonProps } from "../Button/LinkButton/LinkButton";
import {
  FilterFormItemWrapper,
  ICheckboxFilterItem,
  IFilterUpdate,
  ITileFilterProps,
  TileFilter,
} from "../../Navigational/Filters";
import { FormLabel } from "../../Atoms/FormLabel";

export interface ISizeSelectorTilesProps extends ITileFilterProps {
  sizeSelectorLabels?: {
    findMySize?: string;
    sizeChart?: string;
    oneSize?: string;
  };
  findMySizeButton?: TLinkButtonProps;
  sizeChartButton?: TLinkButtonProps;
}

const SizeSelectorTiles: FC<ISizeSelectorTilesProps> = ({
  sizeSelectorLabels,
  singleValue = true,
  filterData,
  findMySizeButton,
  sizeChartButton,
  variant,
  onChange,
  ...filter
}) => {
  const [selectedSize, setSelectedSize] = useState<string>("");

  const handleChange = useCallback(
    ({
      values,
      updates,
    }: {
      values: ICheckboxFilterItem[];
      updates: IFilterUpdate[];
    }) => {
      setSelectedSize(values.find((v) => v.checked)?.title || "");
      onChange && onChange({ values, updates });
    },
    [onChange],
  );

  const textColor = classNames({ "text-color-white": variant === "dark" });

  let filterContent;
  let links;

  const fitFinderIcon = useCallback(
    () => <FitFinderIcon className={`icon-container ${textColor}`} />,
    [textColor],
  );

  if (filterData?.items?.length <= 1) {
    filterContent = (
      <FilterFormItemWrapper type="tile">
        <FormLabel classes={{ root: "checkbox-tile checkbox-tile--light" }}>
          <span className="checkbox-tile__wrap">
            <input
              type="radio"
              name={filterData.name}
              data-testid="one-size-input"
              className="checkbox-tile__input"
              checked
            />
            <span className="checkbox-tile__bg" />
            <span className="checkbox-tile__title">
              {sizeSelectorLabels?.oneSize}
            </span>
            <span className="checkbox-tile__corner" />
          </span>
        </FormLabel>
      </FilterFormItemWrapper>
    );
  } else {
    filterContent = (
      <TileFilter
        filterData={filterData}
        singleValue={singleValue}
        asPureFilter
        onChange={handleChange}
        {...filter}
      />
    );

    links = (
      <>
        <LinkButton
          variant="icon"
          startIcon={fitFinderIcon}
          {...findMySizeButton}
          theme={variant}
          classes={{ root: "text-decoration-underline" }}
        >
          {sizeSelectorLabels?.findMySize}
        </LinkButton>
        <LinkButton
          {...sizeChartButton}
          theme={variant}
          classes={{ root: "text-decoration-underline" }}
        >
          {sizeSelectorLabels?.sizeChart}
        </LinkButton>
      </>
    );
  }

  return (
    <>
      <div className="selector-header">
        <div className="selector-header__title">
          {"Size : "}
          <span
            data-testid="size-selected"
            className="selector-header__option-selected"
          >
            {selectedSize}
          </span>
        </div>
        {links}
      </div>
      {filterContent}
    </>
  );
};

export default SizeSelectorTiles;
